// extracted by mini-css-extract-plugin
export default {"title":"AddEmployeeModal_title__A7CWa"};